import { render, staticRenderFns } from "./DesktopNavigation.vue?vue&type=template&id=01356238"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js"
import style0 from "./DesktopNavigation.vue?vue&type=style&index=0&id=01356238&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports